import React from "react";
import { Box } from "@mui/material";
import PageHeader from "src/components/PageHeader";
import PlanCustomizer from "src/layouts/companyAdmin/settings/components/PlanCustomizer";
import ScheduleMessagingPricing from "src/layouts/companyAdmin/settings/components/ScheduleMessagingPricing";

/**
 * Platform admin — Plans & Pricing.
 * Surfaces the plan/regional-pricing/feature CRUD in the dedicated admin portal
 * (previously only reachable as a role-gated tab inside company settings).
 */
const AdminPlansPage = () => {
  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <PageHeader
        title="Plans & Pricing"
        description="Create plans, set regional pricing, configure schedule messaging fees, and toggle feature flags shown on the public pricing page."
      />
      <ScheduleMessagingPricing />
      <PlanCustomizer />
    </Box>
  );
};

export default AdminPlansPage;
